const crystalGuideGalleryDesigns = Array.isArray(window.__AUCELIA_CRYSTAL_GUIDE_DESIGNS__)
  ? window.__AUCELIA_CRYSTAL_GUIDE_DESIGNS__
  : [];

const crystalGuideLocalDesignerOrigin = window.__AUCELIA_DESIGNER_ORIGIN__ || 'https://aucelia-designer.aucelia-studio.workers.dev';

function resolveCrystalGuideLocalDesignerUrl(value) {
  const url = new URL(String(value ?? ''), crystalGuideLocalDesignerOrigin);
  return url.href;
}

function escapeCrystalGuideGalleryHtml(value) {
  const replacements = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;'
  };
  return String(value ?? '').replace(/[&<>"']/g, (character) => replacements[character]);
}

function buildCrystalGuideGalleryMarkup() {
  const galleryUrl = `${crystalGuideLocalDesignerOrigin}/design-gallery?page=1`;
  const blankDesignerUrl = `${crystalGuideLocalDesignerOrigin}/designer?mode=blank`;
  const total = crystalGuideGalleryDesigns.length;
  const cards = crystalGuideGalleryDesigns.map((design, index) => {
    const position = index + 1;
    const loading = index < 5 ? 'eager' : 'lazy';
    const imageUrl = escapeCrystalGuideGalleryHtml(resolveCrystalGuideLocalDesignerUrl(design.imageUrl));
    const imageSource = index < 6
      ? `src="${imageUrl}"`
      : `data-gallery-image-src="${imageUrl}"`;
    const tabIndex = index < 4 ? 0 : -1;

    return `
      <article
        class="aucelia-guide-gallery__card"
        role="group"
        aria-roledescription="slide"
        aria-label="${position} / ${total}"
        aria-hidden="${index < 4 ? 'false' : 'true'}"
        data-gallery-slide="${index}"
      >
        <a
          class="aucelia-guide-gallery__card-link"
          href="${escapeCrystalGuideGalleryHtml(resolveCrystalGuideLocalDesignerUrl(design.customizeUrl))}"
          aria-label="Customize ${escapeCrystalGuideGalleryHtml(design.name)}, ${escapeCrystalGuideGalleryHtml(design.price)}"
          data-gallery-card-link
          tabindex="${tabIndex}"
        >
          <span class="aucelia-guide-gallery__media">
            <img
              ${imageSource}
              alt="${escapeCrystalGuideGalleryHtml(design.imageAlt)}"
              width="1254"
              height="1254"
              loading="${loading}"
              decoding="async"
            >
          </span>
          <span class="aucelia-guide-gallery__card-copy">
            <span class="aucelia-guide-gallery__card-heading">
              <strong>${escapeCrystalGuideGalleryHtml(design.name)}</strong>
              <span>${escapeCrystalGuideGalleryHtml(design.price)}</span>
            </span>
            <span class="aucelia-guide-gallery__materials">${escapeCrystalGuideGalleryHtml(design.materials)}</span>
            <span class="aucelia-guide-gallery__card-action">
              <span>Customize this design</span>
              <span aria-hidden="true">→</span>
            </span>
          </span>
        </a>
      </article>`;
  }).join('');

  return `
    <div class="aucelia-guide-gallery-ending" data-crystal-guide-gallery-ending data-owner-review>
      <span class="aucelia-guide-gallery-ending__legacy-anchor" id="explore-crystals" aria-hidden="true"></span>
      <section
        class="aucelia-guide-gallery"
        id="crystal-designs"
        role="region"
        aria-roledescription="carousel"
        aria-labelledby="aucelia-guide-gallery-title"
      >
        <div class="aucelia-guide-gallery__inner">
          <header class="aucelia-guide-gallery__header">
            <div class="aucelia-guide-gallery__heading">
              <p class="aucelia-guide-gallery__eyebrow">AUCELIA / DESIGN INSPIRATION</p>
              <h2 id="aucelia-guide-gallery-title">Let inspiration begin<br>with a real design.</h2>
              <p class="aucelia-guide-gallery__summary"><strong>96 designs made from real materials.</strong>Keep one as it is, or open it in the Designer and change every detail.</p>
            </div>
            <div class="aucelia-guide-gallery__intro">
              <a class="aucelia-guide-gallery__all" href="${galleryUrl}">
                <span>View all 96 designs</span>
                <span aria-hidden="true">→</span>
              </a>
            </div>
          </header>

          <div class="aucelia-guide-gallery__viewport">
            <div class="aucelia-guide-gallery__controls">
              <div class="aucelia-guide-gallery__buttons">
                <button class="aucelia-guide-gallery__autoplay" type="button" data-gallery-autoplay-toggle>
                  <span data-gallery-autoplay-label>Pause carousel</span>
                </button>
                <button class="aucelia-guide-gallery__arrow" type="button" aria-label="Previous design" data-gallery-previous>
                  <span aria-hidden="true">←</span>
                </button>
                <button class="aucelia-guide-gallery__arrow" type="button" aria-label="Next design" data-gallery-next>
                  <span aria-hidden="true">→</span>
                </button>
              </div>
              <p class="aucelia-guide-gallery__progress" aria-live="off">
                <span data-gallery-range>01–04</span>
                <span aria-hidden="true">/</span>
                <span>96</span>
              </p>
              <p class="aucelia-guide-gallery__status" aria-live="polite" aria-atomic="true" data-gallery-status></p>
            </div>
            <div class="aucelia-guide-gallery__rail" data-gallery-rail>
              ${cards}
            </div>
          </div>
        </div>
      </section>

      <section class="aucelia-guide-gallery-close" id="designer-cta" aria-labelledby="aucelia-guide-gallery-close-title">
        <div class="aucelia-guide-gallery-close__inner">
          <div>
            <p class="aucelia-guide-gallery-close__eyebrow">YOUR DESIGN / YOUR PACE</p>
            <h2 id="aucelia-guide-gallery-close-title">Already have a direction?<br>Begin with a blank design.</h2>
          </div>
          <a class="aucelia-guide-gallery-close__button" href="${blankDesignerUrl}">
            <span>Start designing</span>
            <span aria-hidden="true">→</span>
          </a>
        </div>
      </section>
    </div>`;
}

function createCrystalGuideGalleryAutoplay({
  total,
  getVisibleCount,
  onIndexChange,
  schedule = setTimeout,
  cancel = clearTimeout,
  delay = 3000
}) {
  let index = 0;
  let timer = null;
  let playing = false;

  function getMaximumIndex() {
    return Math.max(0, total - Math.max(1, getVisibleCount()));
  }

  function goTo(nextIndex, notify = true) {
    const maximumIndex = getMaximumIndex();
    index = Math.min(maximumIndex, Math.max(0, Number(nextIndex) || 0));
    if (notify) onIndexChange(index);
    return index;
  }

  function next() {
    return goTo(index >= getMaximumIndex() ? 0 : index + 1);
  }

  function previous() {
    return goTo(index <= 0 ? getMaximumIndex() : index - 1);
  }

  function queueNext() {
    if (!playing || timer !== null) return;
    timer = schedule(() => {
      timer = null;
      next();
      queueNext();
    }, delay);
  }

  function play() {
    if (playing) return;
    playing = true;
    queueNext();
  }

  function pause() {
    playing = false;
    if (timer !== null) {
      cancel(timer);
      timer = null;
    }
  }

  return {
    getIndex: () => index,
    getMaximumIndex,
    goTo,
    isPlaying: () => playing,
    next,
    pause,
    play,
    previous
  };
}

function getNearestCrystalGuideGalleryIndex({ scrollLeft, step, maximumIndex }) {
  if (!Number.isFinite(step) || step <= 0) return 0;
  return Math.min(
    Math.max(0, Number(maximumIndex) || 0),
    Math.max(0, Math.round((Number(scrollLeft) || 0) / step))
  );
}

function initialiseCrystalGuideGalleryCarousel(root) {
  const rail = root.querySelector('[data-gallery-rail]');
  const cards = Array.from(root.querySelectorAll('[data-gallery-slide]'));
  const cardLinks = cards.map((card) => card.querySelector('[data-gallery-card-link]'));
  const autoplayButton = root.querySelector('[data-gallery-autoplay-toggle]');
  const autoplayLabel = root.querySelector('[data-gallery-autoplay-label]');
  const previousButton = root.querySelector('[data-gallery-previous]');
  const nextButton = root.querySelector('[data-gallery-next]');
  const range = root.querySelector('[data-gallery-range]');
  const status = root.querySelector('[data-gallery-status]');
  const visibilityTarget = root.querySelector('.aucelia-guide-gallery__viewport') || root;
  if (!rail || !cards.length || !autoplayButton || !autoplayLabel || !previousButton || !nextButton || !range || !status) return;

  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const desktop = window.matchMedia('(min-width: 990px)');
  const tablet = window.matchMedia('(min-width: 700px)');
  let userPaused = reducedMotion.matches;
  let hoverPaused = false;
  let inViewport = typeof window.IntersectionObserver !== 'function';
  let scrollFrame = null;
  let activeCards = new Set(cards.filter((card) => card.getAttribute('aria-hidden') !== 'true'));

  function getVisibleCount() {
    if (desktop.matches) return 4;
    if (tablet.matches) return 2;
    return 1;
  }

  function formatPosition(value) {
    return String(value).padStart(2, '0');
  }

  function hydrateImagesAroundIndex(index) {
    const start = Math.max(0, index - 1);
    const end = Math.min(cards.length - 1, index + getVisibleCount() + 2);
    for (let cardIndex = start; cardIndex <= end; cardIndex += 1) {
      const image = cards[cardIndex]?.querySelector('img[data-gallery-image-src]');
      if (!image) continue;
      image.src = image.dataset.galleryImageSrc;
      image.removeAttribute('data-gallery-image-src');
    }
  }

  function updateInteractiveCardLinks(index) {
    const nextActiveCards = new Set();
    const end = Math.min(cardLinks.length, index + getVisibleCount());
    for (let cardIndex = index; cardIndex < end; cardIndex += 1) {
      const card = cards[cardIndex];
      const link = cardLinks[cardIndex];
      if (!card || !link) continue;
      card.setAttribute('aria-hidden', 'false');
      link.tabIndex = 0;
      nextActiveCards.add(card);
    }
    activeCards.forEach((card) => {
      if (nextActiveCards.has(card)) return;
      card.setAttribute('aria-hidden', 'true');
      const link = card.querySelector('[data-gallery-card-link]');
      if (link) link.tabIndex = -1;
    });
    activeCards = nextActiveCards;
  }

  function updateProgress(index) {
    const visibleCount = getVisibleCount();
    const first = index + 1;
    const last = Math.min(cards.length, index + visibleCount);
    range.textContent = visibleCount === 1
      ? formatPosition(first)
      : `${formatPosition(first)}–${formatPosition(last)}`;
    hydrateImagesAroundIndex(index);
    updateInteractiveCardLinks(index);
  }

  function announceCurrentPosition(index, action) {
    const visibleCount = getVisibleCount();
    const last = Math.min(cards.length, index + visibleCount);
    const designName = crystalGuideGalleryDesigns[index]?.name || '';
    status.textContent = `${action}. Showing designs ${index + 1} to ${last}, beginning with ${designName}.`;
  }

  function scrollToIndex(index) {
    const card = cards[index];
    if (!card) return;
    const firstCardOffset = cards[0]?.offsetLeft ?? 0;
    rail.scrollTo({
      left: Math.max(0, card.offsetLeft - firstCardOffset),
      behavior: reducedMotion.matches ? 'auto' : 'smooth'
    });
    updateProgress(index);
  }

  const autoplay = createCrystalGuideGalleryAutoplay({
    total: cards.length,
    getVisibleCount,
    onIndexChange: scrollToIndex,
    schedule: window.setTimeout.bind(window),
    cancel: window.clearTimeout.bind(window),
    delay: 3000
  });

  function updateAutoplayButton() {
    const playing = autoplay.isPlaying();
    autoplayButton.dataset.state = playing ? 'playing' : 'paused';
    autoplayButton.setAttribute('aria-label', playing ? 'Pause design carousel' : 'Play design carousel');
    autoplayLabel.textContent = playing ? 'Pause carousel' : 'Play carousel';
  }

  function syncPlayback() {
    if (userPaused || hoverPaused || !inViewport || document.hidden) autoplay.pause();
    else autoplay.play();
    updateAutoplayButton();
  }

  function pauseForUser() {
    userPaused = true;
    syncPlayback();
  }

  autoplayButton.addEventListener('click', () => {
    userPaused = !userPaused;
    syncPlayback();
    status.textContent = userPaused ? 'Carousel paused' : 'Carousel playing';
  });

  previousButton.addEventListener('click', () => {
    pauseForUser();
    autoplay.previous();
    announceCurrentPosition(autoplay.getIndex(), 'Previous design shown');
  });

  nextButton.addEventListener('click', () => {
    pauseForUser();
    autoplay.next();
    announceCurrentPosition(autoplay.getIndex(), 'Next design shown');
  });

  root.addEventListener('mouseenter', () => {
    hoverPaused = true;
    syncPlayback();
  });

  root.addEventListener('mouseleave', () => {
    hoverPaused = false;
    syncPlayback();
  });

  root.addEventListener('focusin', pauseForUser);
  rail.addEventListener('pointerdown', pauseForUser, { passive: true });
  rail.addEventListener('touchstart', pauseForUser, { passive: true });
  rail.addEventListener('wheel', (event) => {
    if (Math.abs(event.deltaX) > Math.abs(event.deltaY)) pauseForUser();
  }, { passive: true });

  rail.addEventListener('scroll', () => {
    if (scrollFrame !== null) return;
    scrollFrame = window.requestAnimationFrame(() => {
      scrollFrame = null;
      const firstCardOffset = cards[0]?.offsetLeft ?? 0;
      const secondCardOffset = cards[1]?.offsetLeft ?? firstCardOffset;
      const closestIndex = getNearestCrystalGuideGalleryIndex({
        scrollLeft: rail.scrollLeft,
        step: secondCardOffset - firstCardOffset,
        maximumIndex: autoplay.getMaximumIndex()
      });
      autoplay.goTo(closestIndex, false);
      updateProgress(autoplay.getIndex());
    });
  }, { passive: true });

  document.addEventListener('visibilitychange', syncPlayback);
  window.addEventListener('resize', () => {
    autoplay.goTo(Math.min(autoplay.getIndex(), autoplay.getMaximumIndex()), false);
    scrollToIndex(autoplay.getIndex());
  });

  if (typeof reducedMotion.addEventListener === 'function') {
    reducedMotion.addEventListener('change', (event) => {
      if (event.matches) userPaused = true;
      syncPlayback();
    });
  }

  if (typeof window.IntersectionObserver === 'function') {
    const observer = new window.IntersectionObserver((entries) => {
      inViewport = entries.some((entry) => entry.isIntersecting && entry.intersectionRatio >= 0.35);
      syncPlayback();
    }, { threshold: [0, 0.35, 0.65] });
    observer.observe(visibilityTarget);
  }

  autoplay.goTo(0);
  syncPlayback();
}

function installCrystalGuideGalleryEnding() {
  const guideGalleryUrl = `${window.location.origin.replace(/\/$/, '')}/pages/crystal-guide#crystal-designs`;
  document.querySelectorAll('[data-aucelia-guide-free-choice]').forEach((freeChoiceLink) => {
    freeChoiceLink.href = guideGalleryUrl;
  });

  if (document.querySelector('[data-crystal-guide-gallery-ending]')) return;

  const target = document.querySelector('.section-aucelia-crystal-designer-cta');
  if (!target) return;

  target.innerHTML = buildCrystalGuideGalleryMarkup();
  if (typeof target.querySelector !== 'function') return;

  const root = target.querySelector('[data-crystal-guide-gallery-ending]');
  if (root) initialiseCrystalGuideGalleryCarousel(root);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', installCrystalGuideGalleryEnding, { once: true });
} else {
  installCrystalGuideGalleryEnding();
}

